import { ErrorType } from '../../errors-handler/ErrorsHandler.types';
import { extractErrorEventInfo } from '../ErrorViews.utils';

export const isOfflineError = ({ event, isNetworkAvailable }: ErrorType) => {
  const { message } = extractErrorEventInfo(event);
  return !isNetworkAvailable && message.includes('Failed to fetch');
};
